import {PlayerIframeUrlVars} from './types'
import {Segment} from '../SegmentsPlayer/types'
import {createLogger} from 'logging'
const logger = createLogger('segments-player', 'api')

const validateNullSegments = (segments: Segment[], powtoon: string) => {
  if (segments.some((seg => seg.audio_url === null && seg.video_url === null))) {
    throw new Error(`Found null segment in ${powtoon}`)
  }
}

interface ServerResponseContent extends Object {
  segments?: Segment[],
  video_url?: string,
  version?: string,
  thumb_url: string,
  isV2: boolean
}

const getEndpoint = (hostname: string, powtoon: string, public_link_token?: string) =>
  `${hostname}/api/v2/powtoons/${powtoon}?include_content=true${
    public_link_token ? `&public_link_token=${public_link_token}` : ''
  }`

interface ServerResponse extends Object {content: ServerResponseContent, thumb_url: string}
export const loadDocumentData = async ({hostname, powtoon, public_link_token}: PlayerIframeUrlVars):
  Promise<ServerResponseContent> => {
  try {
    if (!hostname) {throw new Error('Missing hostname')}
    if (!powtoon) {throw new Error('Missing powtoon ID')}

    const powtoonUrl = getEndpoint(hostname, powtoon, public_link_token)

    const result: ServerResponse = (await (await fetch(powtoonUrl)).json())
    const isV2 = Number(result?.content?.version) >= 2 // consider also version 2.1 as valid
    if (!isV2 && !result?.content?.segments && !result?.content?.video_url) {
      throw new Error('Content is missing segments and video_url')
    }

    if (result.content.segments) {
      validateNullSegments(result.content.segments, powtoon)
    }
    
    return {
      ...result.content,
      thumb_url: result.thumb_url,
      isV2
    }
  }
  catch (error) {
    logger.error(error)
    throw error
  }
}
